import { ArticleHeading4, Label, Tooltip, UIText2 } from '@cian/ui-kit';
import { IconProductCianLogo16 } from '@cian/ui-kit-design-tokens/icons';

import { type FC } from 'react';

import { TooltipContent } from '../../components/TooltipContent';

export const UniqueForCianLabelContainer: FC = () => {
  return (
    <Tooltip
      placement="bottom"
      theme="white"
      title={
        <TooltipContent>
          <ArticleHeading4>Только на Циан</ArticleHeading4>
          <UIText2>
            За последние сутки мы не нашли этот объект
            <br />в открытом доступе на других агрегаторах
          </UIText2>
        </TooltipContent>
      }
    >
      <Label
        background="surface-main-default"
        color="accent-main-primary"
        data-testid="publisher-labels.unique-for-cian"
        icon={<IconProductCianLogo16 color="accent-main-primary" />}
      >
        Только на Циан
      </Label>
    </Tooltip>
  );
};
